import React, {HTMLAttributes, forwardRef} from 'react';
import {cn} from '@/utils/common_functions';

export const TextVariants = {
  heading: 'text-2xl sm:text-3xl font-headingBold',
  headingSemiBold: 'text-2xl sm:text-3xl font-headingSemiBold',
  headingMedium: 'text-2xl sm:text-3xl font-headingMedium',
  
  subheading: 'text-2xl sm:text-3xl font-headingSemiBold',
  subheadingSemiBold: 'text-2xl sm:text-3xl font-headingSemiBold',
  subheadingMedium: 'text-2xl sm:text-3xl font-headingMedium',

  titleLarge: 'text-xl md:text-2xl font-headingSemiBold',
  title: 'text-lg md:text-xl font-headingSemiBold',

  subtitle: 'text-base md:text-lg font-headingSemiBold',
  medium: 'text-base md:text-lg font-headingMedium',
  body: 'text-sm md:text-base font-body',
  small: 'text-xs md:text-sm font-body',
  tiny: 'text-xs font-body',
  free: '' // opt out of variant

} as const;

interface UITextProps
  extends Omit<HTMLAttributes<HTMLParagraphElement>, 'style'> {
  variant?: keyof typeof TextVariants;
  style?: React.CSSProperties;
}

export const Text = forwardRef<HTMLParagraphElement, UITextProps>((props, ref) => {
  const {variant, children, style, className, ...rest} = props;

  return (
    <p
      ref={ref}
      style={style as React.CSSProperties}
      className={cn(className, [TextVariants[variant ?? "body"]])}
      {...rest}>
      {children}
    </p>
  );
});


Text.displayName = 'Text';